import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { flatten, uniq, startCase, isEqual } from 'lodash';
import { useState } from 'react';
import { defaultFonts, themes, defaultThemePreviews, changeTheme } from '@/config/theme';
import SegmentedControl, { Segment } from '@/components/SegmentedControl';
import ThemeVariants from '@/components/Editor/Form/fields/ThemeVariants';
import ThemeOptions from './ThemeOptions';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var GlobeIcon = function GlobeIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_8210_393)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.3333 9.99984C18.3333 14.6022 14.6023 18.3332 9.99996 18.3332M18.3333 9.99984C18.3333 5.39746 14.6023 1.6665 9.99996 1.6665M18.3333 9.99984H1.66663M9.99996 18.3332C5.39759 18.3332 1.66663 14.6022 1.66663 9.99984M9.99996 18.3332C12.0844 16.0512 13.2689 13.0898 13.3333 9.99984C13.2689 6.90987 12.0844 3.94846 9.99996 1.6665M9.99996 18.3332C7.91556 16.0512 6.731 13.0898 6.66663 9.99984C6.731 6.90987 7.91556 3.94846 9.99996 1.6665M1.66663 9.99984C1.66663 5.39746 5.39759 1.6665 9.99996 1.6665",
        stroke: "#1E1E1E",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8210_393",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  }));
};

GlobeIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var SunIcon = function SunIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_8210_399)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M10 0.833496V2.50016M10 17.5002V19.1668M3.51671 3.51683L4.70004 4.70016M15.3 15.3002L16.4834 16.4835M0.833374 10.0002H2.50004M17.5 10.0002H19.1667M3.51671 16.4835L4.70004 15.3002M15.3 4.70016L16.4834 3.51683M14.1667 10.0002C14.1667 12.3013 12.3012 14.1668 10 14.1668C7.69885 14.1668 5.83337 12.3013 5.83337 10.0002C5.83337 7.69898 7.69885 5.8335 10 5.8335C12.3012 5.8335 14.1667 7.69898 14.1667 10.0002Z",
        stroke: "#757575",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8210_399",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  }));
};

SunIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var MoonIcon = function MoonIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.5 10.6583C17.369 12.0768 16.8366 13.4287 15.9652 14.5557C15.0939 15.6826 13.9196 16.5382 12.5798 17.0221C11.24 17.5061 9.79003 17.5984 8.39962 17.2884C7.00922 16.9784 5.73587 16.2788 4.72856 15.2715C3.72125 14.2642 3.02166 12.9908 2.71163 11.6004C2.4016 10.21 2.49397 8.76007 2.97792 7.42025C3.46188 6.08042 4.3174 4.90614 5.44438 4.03479C6.57137 3.16345 7.9232 2.63109 9.34171 2.5C8.51122 3.62356 8.11158 5.00787 8.21548 6.40118C8.31939 7.79448 8.91992 9.10421 9.90787 10.0922C10.8958 11.0801 12.2056 11.6807 13.5989 11.7846C14.9922 11.8885 16.3765 11.4888 17.5 10.6583Z",
      stroke: "#757575",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

MoonIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const TAG_ICONS = {
  light: /*#__PURE__*/_jsx(SunIcon, {}),
  dark: /*#__PURE__*/_jsx(MoonIcon, {})
};

const ThemePicker = _ref => {
  let {
    nameSpace,
    theme: defaultTheme,
    colorPallet,
    palletColorOverrides,
    previews = defaultThemePreviews,
    customTags,
    disabled = false,
    hideFooter = false,
    hideAllTag = false,
    onChange,
    onLoadFonts,
    onOverridePalletColors
  } = _ref;
  const uniqueTags = uniq(flatten(themes.map(theme => theme.tags)));
  const activeThemeId = defaultTheme || themes[0].id;
  const activeTheme = themes.find(theme => theme.id === activeThemeId);
  const {
    0: activeTag,
    1: setActiveTag
  } = useState(hideAllTag ? uniqueTags[0] : 'all');
  const filteredThemes = activeTag === 'all' ? themes : themes.filter(theme => theme.tags.includes(activeTag));

  const handleThemeSelect = theme => {
    var _theme$fonts;

    typeof onChange === 'function' && onChange(changeTheme(theme)); // Load Theme specific fonts
    // if they are different from the default fonts

    const isFontChanged = Boolean((_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.length) && !isEqual(defaultFonts, theme.fonts);
    typeof onLoadFonts === 'function' && onLoadFonts(isFontChanged ? theme.fonts : null);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs(SegmentedControl, {
      disabled: disabled,
      defaultValue: activeTag,
      onChange: setActiveTag,
      className: styles.segments,
      children: [!hideAllTag ? /*#__PURE__*/_jsx(Segment, {
        value: "all",
        label: "All",
        leftIcon: /*#__PURE__*/_jsx(GlobeIcon, {})
      }) : null, uniqueTags.map(tag => /*#__PURE__*/_jsx(Segment, {
        value: tag,
        label: startCase(tag),
        leftIcon: TAG_ICONS[tag]
      }, `${nameSpace}-${tag}`)), customTags]
    }), /*#__PURE__*/_jsx(ThemeOptions, {
      themes: filteredThemes,
      activeThemeId: activeThemeId,
      previews: previews,
      disabled: disabled,
      onChange: handleThemeSelect
    }), !hideFooter ? /*#__PURE__*/_jsx("footer", {
      className: styles.footer,
      children: activeTheme ? /*#__PURE__*/_jsx(ThemeVariants, _objectSpread({
        nameSpace: `${nameSpace}-${activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.id}`,
        colorPallet: colorPallet || (activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.colorPallets[0].colors),
        colorPallets: (activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.colorPallets) || [],
        palletColorOverrides: palletColorOverrides,
        disabled: disabled,
        defaults: {
          colors: activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.colorPallets[0].colors
        }
      }, !disabled && {
        onChange: colorPallet => onChange({
          colorPallet
        }),
        onOverridePalletColors: onOverridePalletColors
      })) : /*#__PURE__*/_jsx(_Fragment, {})
    }) : null]
  });
};

export default ThemePicker;